import React from "react";
import SelectOneQuestion from "./SelectOne";
import SelectOneENPS from "./SelectOneENPS";

const SelectENPSQuestion = (props) => (
    <SelectOneQuestion {...props} CustomSelectComponent={SelectOneENPS} />
);

export default React.memo(SelectENPSQuestion);
